import { render, staticRenderFns } from "./ste-staking.vue?vue&type=template&id=2e79db8f&scoped=true&"
import script from "./ste-staking.vue?vue&type=script&lang=ts&"
export * from "./ste-staking.vue?vue&type=script&lang=ts&"
import style0 from "./ste-staking.vue?vue&type=style&index=0&id=2e79db8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79db8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow,VSpacer})
